
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke401aRequest, Sgke401aResponse, Sgke401aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke401aService {

  /**
   * コンストラクタ
   * @param {Sgke401aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke401aService
   */
  constructor(
    public service: Sgke401aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE401A_欠損承認依頼・最終承認初期表示API呼び出し
   * @param {Sgke401aRequest} request 
   * @returns {Observable<Sgke401aResponse>}
   * @memberof UsedSgke401aService
   */
  public doSgke401a(request: Sgke401aRequest): Observable<Sgke401aResponse> {
    return this.service.sgke401aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE401A');
          return throwError(err.message);
        })
      );
  }

}
